<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增 AI 风格
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--two">
          <div class="filterItem">
            <span class="searchText">AppKey</span>
            <el-input
              class="filterControl"
              placeholder="请输入 AppKey"
              prefix-icon="el-icon-search"
              :value="appKey"
              size="small"
              clearable
              @input="$emit('update:appKey', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">分类</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="type"
              placeholder="全部分类"
              size="small"
              clearable
              @change="$emit('update:type', $event)"
            >
              <el-option label="文生图" value="1" />
              <el-option label="图生图" value="2" />
              <el-option label="角色文生图" value="3" />
              <el-option label="角色图生图" value="4" />
            </el-select>
          </div>
          <div class="filterItem">
            <span class="searchText">版本</span>
            <el-input
              class="filterControl"
              placeholder="请输入版本"
              prefix-icon="el-icon-search"
              :value="version"
              size="small"
              clearable
              @input="$emit('update:version', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">风格</span>
            <el-input
              class="filterControl"
              placeholder="请输入风格"
              prefix-icon="el-icon-search"
              :value="style"
              size="small"
              clearable
              @input="$emit('update:style', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem filterItem--wide">
            <span class="searchText">状态</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="status"
              placeholder="全部状态"
              size="small"
              clearable
              @change="$emit('update:status', $event)"
            >
              <el-option label="上线" :value="1" />
              <el-option label="下线" :value="0" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiStyleListFilterPanel',
  props: {
    appKey: { type: String, default: '' },
    type: { type: String, default: '' },
    version: { type: String, default: '' },
    style: { type: String, default: '' },
    status: { type: [String, Number], default: '' },
    activeFilterCount: { type: Number, default: 0 },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
</style>